<template>
<div class="chapter">
<div class="inner_page">
<p class="copy11">Text copyright © 2015 by Stephanie Perry Moore</p>
<p class="copy">All rights reserved. International copyright secured. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an acknowledged review.</p>
<p class="copy">Darby Creek <br/>A division of Lerner Publishing Group, Inc. <br/>241 First Avenue North<br/>Minneapolis, MN 55401 USA</p>
<p class="copy">For reading levels and more information, look up this title at <a href="http://www.lernerbooks.com" target="_blank">www.lernerbooks.com</a>.</p>
<p class="copy">Cover: © Luba V Nel/Dreamstime.com (woman); © Andrew Marginean/Dreamstime.com (brick wall); © Andrew Scherbackov/Shutterstock.com (notebook paper).</p>
<p class="copy">Interior: © Andrew Marginean/Dreamstime.com (brick hall background); © Sam74100/Dreamstime.com, pp. 1, 41, 79; © Luba V Nel/Dreamstime.com, pp. 10, 49, 87; © iStockphoto.com/kate_sept2004, pp. 18, 57, 93; © Hemera Technologies/AbleStock.com/Thinkstock, pp. 26, 64, 101; © Rauluminate/iStock/Thinkstock, pp. 34, 72, 109.</p>
<p class="copy">Main body text set in Janson Text LT Std 12/17.5.<br/>Typeface provided by Adobe Systems.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Moore, Stephanie Perry.</p>
<p class="copyia">On your knees / by Stephanie Perry Moore.</p>
<p class="copy3">pages cm. — (The Swoop List ; #2)</p>
<p class="copyia">Summary: Determined to turn their presence on the “Swoop List” into a positive thing, five Georgia high school girls face new challenges at home and in school by believing in something greater than themselves, especially their friendship.</p>
<p class="copyi">ISBN 978-1-4677-5805-5 (lib. bdg. : alk. paper)</p>
<p class="copyi">ISBN 978-1-4677-6050-8 (pbk.)</p>
<p class="copyi">ISBN 978-1-4677-6192-5 (EB pdf)</p>
<p class="copyia">[1. Conduct of life—Fiction. 2. Interpersonal relations—Fiction. 3. Dating (Social customs)—Fiction. 4. High schools—Fiction. 5. Schools—Fiction. 6. Sex—Fiction.] I. Title.<br/>PZ7.M788125On 2015<br/>[Fic]—dc23</p>
<p class="copyr">2014025729</p>
<p class="copy">Manufactured in the United States of America<br/>1 – SB – 12/31/14<br/>eISBN: 978-1-46776-192-5 (pdf)<br/>eISBN: 978-1-46777-889-3 (ePub)<br/>eISBN: 978-1-46777-888-6 (mobi)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7331d954